import React from "react";
import { Link } from "react-router-dom";
import "./Blogs.css";

/** 8 live blog cards (your topics) */
const BLOGS = [
  {
    id: 1,
    img: "./blogone.png",
    title: "Early Signs You Need Expert Residential Carpet Cleaners in Everett",
    excerpt:
      "From rough carpet texture to stubborn recurring spots and uneven color — here are the early signals your Everett home needs professional care.",
    path: "/blog/everett-expert-residential-carpet-cleaners",
    date: "Nov 2025",
    readTime: "6 min read",
    category: "Carpet • Everett",
  },
  {
    id: 2,
    img: "./blogtwo.png",
    title: "How Bellevue Couch Cleaning Services Extend Your Furniture's Life",
    excerpt:
      "Why scheduled upholstery cleaning prevents fiber wear, removes allergens, and keeps your Bellevue living room feeling fresh.",
    path: "/blog/bellevue-couch-cleaning-services",
    date: "Nov 2025",
    readTime: "7 min read",
    category: "Upholstery • Bellevue",
  },
  {
    id: 3,
    img: "./blogthree.png",
    title: "How Cleaning Services in Lynnwood Help Prepare Homes for the Holidays",
    excerpt:
      "Deep-clean key areas before guests arrive. See the high-impact zones pros hit first in Lynnwood holiday prep.",
    path: "/blog/lynnwood-holiday-cleaning-services",
    date: "Nov 2025",
    readTime: "5 min read",
    category: "Seasonal • Lynnwood",
  },
  {
    id: 4,
    img: "./blogfour.png",
    title: "How to Get Rid of Grout Stains in Lynnwood Before the Holidays",
    excerpt:
      "DIY options vs. pro extraction and sealing. What really removes grease, hard water, and mildew from grout lines.",
    path: "/blog/lynnwood-grout-stains",
    date: "Nov 2025",
    readTime: "6 min read",
    category: "Tile & Grout • Lynnwood",
  },
  {
    id: 5,
    img: "./blogfive.png",
    title: "Kirkland Carpet Care: Deep Cleaning or Spot Treatments?",
    excerpt:
      "When a quick spot fix is fine — and when your carpet needs a full hot-water extraction to reset fibers and remove odors.",
    path: "/blog/kirkland-deep-cleaning-vs-spot-treatments",
    date: "Nov 2025",
    readTime: "6 min read",
    category: "Carpet • Kirkland",
  },
  {
    id: 6,
    img: "./blogsix.png",
    title: "Seattle Holiday Prep: Why Book Residential Carpet Cleaning Early",
    excerpt:
      "Beat the November–December rush. Early booking means cleaner carpets, lower stress, and better time slots.",
    path: "/blog/seattle-holiday-carpet-cleaning-early",
    date: "Nov 2025",
    readTime: "5 min read",
    category: "Carpet • Seattle",
  },
  {
    id: 7,
    img: "./blogseven.png",
    title: "What Happens If You Skip Annual Hardwood Floor Cleaning in Tacoma",
    excerpt:
      "Haze, residues, and premature wear: how Tacoma's wet winters speed up damage — and what a pro annual clean prevents.",
    path: "/blog/tacoma-skip-annual-hardwood-cleaning",
    date: "Nov 2025",
    readTime: "7 min read",
    category: "Hardwood • Tacoma",
  },
  {
    id: 8,
    img: "./blogeight.png",
    title: "Why a Bellevue Carpet Looks Worn Post-Cleaning & How Stretching Helps",
    excerpt:
      "Ripples after drying usually reveal pre-existing looseness. How power-stretching restores fit, feel, and safety.",
    path: "/blog/bellevue-carpet-looks-worn-stretching-helps",
    date: "Nov 2025",
    readTime: "6 min read",
    category: "Carpet Care • Bellevue",
  },
];

export default function AllBlogs() {
  return (
    <section className="blogs-section">
      <div className="blogs-container">
        <header className="blogs-header">
          <h2 className="blogs-title">Latest Articles</h2>
          <p className="blogs-subtitle">
            Insights, tips, and local guides from our cleaning experts
          </p>
        </header>

        <div className="blogs-grid">
          {BLOGS.map(
            ({ id, img, title, excerpt, path, date, readTime, category }) => (
              <article key={id} className="blog-card">
                <div className="blog-card-inner">
                  <div className="blog-card-media">
                    <div className="blog-image-container">
                      <img
                        src={img}
                        alt={title}
                        loading="lazy"
                        className="blog-card-image"
                      />
                      <div className="image-overlay" />
                    </div>
                    <div className="blog-card-category">{category}</div>
                  </div>

                  <div className="blog-card-content">
                    <div className="blog-card-meta">
                      <span className="blog-card-date">{date}</span>
                      <span className="blog-card-read-time">{readTime}</span>
                    </div>
                    <h3 className="blog-card-title">{title}</h3>
                    <p className="blog-card-excerpt">{excerpt}</p>

                    <Link to={path} className="blog-card-link">
                      Read more
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        aria-hidden="true"
                      >
                        <path
                          d="M5 12H19M19 12L12 5M19 12L12 19"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </Link>
                  </div>
                </div>
              </article>
            )
          )}
        </div>
      </div>
    </section>
  );
}